import React, {useContext} from "react";
import {Box, Stack} from "@mui/material";
import {
  CONTEXT_ACTION_TYPE,
  DataStoreContext,
  STEP_ORDERS,
  STEPS,
  useStep,
  validateStepOutput,
  WorkInstancePayload
} from "../../contexts/OperatingTestContext";
import {useWorkInstanceByClass} from "../../hooks/useWorkInstance";
import {FetchMessage} from "../../../../hooks/useFetchAllQuery";
import WorkInstanceListItem from "../../../operatingEnvironment/components/lists/WorkInstanceListItem";
import TitleWithBackButton from "../utils/TitleWithBackButton";

export default function WorkInstanceSelectionStep() {
  if (!useIsShow()) {
    throw new Error('WorkInstanceSelectionStep is not shown');
  }

  const {state, dispatch} = useContext(DataStoreContext);
  const [, setStep] = useStep();
  useWorkInstanceByClass({
    enableAutoFetch: true,
    workClassIds: state.workClassStep.selectedWorkClass?.attr["class-id"]
      ? [state.workClassStep.selectedWorkClass.attr["class-id"]]
      : [],
    onChange: (newData, newStatus) => {
      dispatch({
        type: CONTEXT_ACTION_TYPE.WORK_INSTANCE,
        payload: {
          workInstances: newData,
          searchStatus: newStatus,
        } satisfies WorkInstancePayload
      });
    }
  })

  return (
    <Stack gap={4}>
      <TitleWithBackButton
        title={`対象物名：${state.workClassStep.selectedWorkClass?.attr.nameJp ?? ''}`}
        onClick={() => {
          setStep(STEP_ORDERS[STEPS.WORK_INSTANCE_SELECTION].PREV);
        }}
        prevText='検索結果に戻る'
        actionText='サンプルを選択してください。'
      />

      <Box>
        <Box display='flex' flexWrap='wrap' gap={2}>
          {state.workInstanceStep.workInstances
            .flatMap(instance => Object.values(instance.items))
            .map((workInstance) => (
              <WorkInstanceListItem
                key={workInstance.attr["instance-id"]}
                item={workInstance}
                onClick={() => {
                  dispatch({
                    type: CONTEXT_ACTION_TYPE.WORK_INSTANCE,
                    payload: {
                      selectedWorkInstance: workInstance,
                    } satisfies WorkInstancePayload
                  });
                  setStep(STEP_ORDERS[STEPS.WORK_INSTANCE_SELECTION].NEXT);
                }}
              />
            ))}
        </Box>
        <FetchMessage
          data={state.workInstanceStep.workInstances}
          status={state.workInstanceStep.searchStatus}
          isEmpty={(items) => items.flatMap((item) => Object.keys(item.items)).length === 0}
        />
      </Box>
    </Stack>
  );
}

function useIsShow() {
  const [step] = useStep();
  const {state} = useContext(DataStoreContext);

  return step === STEPS.WORK_INSTANCE_SELECTION &&
    validateStepOutput(state, STEP_ORDERS[STEPS.WORK_INSTANCE_SELECTION].PREV);
}
